import { useTheme } from '@mui/material'
import { i18WithParams as t } from '@shared/locales'
import { ColorChip } from 'color_chip'
import { InvoiceClientDto } from 'service-api/src/types'
import { getInvoiceDates, getInvoiceSubStatus } from 'shared'

export const InvoiceStatus = ({ invoice }: { invoice: InvoiceClientDto }) => {
  const theme = useTheme()
  const { primary, success, error } = theme.palette!
  const today = new Date().getTime(),
    invoiceDates = getInvoiceDates(invoice)
  const startDate = invoiceDates.startDate.getTime(),
    endDate = invoiceDates.endDate.getTime()
  const invoiceSubStatus = getInvoiceSubStatus(invoice)

  if (invoiceSubStatus.isCanceled) {
    return <ColorChip label={t('global.label.canceled')} bgColor={error.shade12} textColor={error.main} />
  } else if (invoiceSubStatus.isSold) {
    return <ColorChip label={t('global.label.sold')} bgColor={success.shade12} textColor={success.main} />
  } else if (invoice.invoiceStatus === 'CONFIRMED') {
    if (today < startDate) {
      return <ColorChip label={t('global.label.upcoming')} bgColor={primary.shade12} textColor={primary.main} />
    } else if (today >= startDate && today <= endDate) {
      return <ColorChip label={t('global.label.inProgress')} bgColor={success.shade12} textColor={success.main} />
    } else {
      return <ColorChip label={t('global.label.completed')} />
    }
  }
  return null
}
